import { Editor } from '@tiptap/react';

export interface ToolbarAction {
  name: string;
  icon: string;
  label: string;
  command: (editor: Editor) => void;
}

export const toolbarActions: ToolbarAction[] = [
  {
    name: 'bold',
    icon: 'blodFont',
    label: '加粗',
    command: (editor) => editor.chain().focus().toggleBold().run(),
  },
  {
    name: 'italic',
    icon: 'italic',
    label: '斜体',
    command: (editor) => editor.chain().focus().toggleItalic().run(),
  },
  {
    name: 'strike',
    icon: 'strikethrough',
    label: '删除线',
    command: (editor) => editor.chain().focus().toggleStrike().run(),
  },
  {
    name: 'color',
    icon: 'colorBar',
    label: '颜色',
    command: () => {}, // 交由 TiptapEditor 处理
  },
  {
    name: 'link',
    icon: 'links',
    label: '链接',
    command: () => {}, // 交由 TiptapEditor 处理
  },
  {
    name: 'topic',
    icon: 'topic',
    label: '话题',
    command: (editor) => {}, // 需自定义
  },
  {
    name: 'mention',
    icon: 'atfirends',
    label: '@好友',
    command: (editor) => {}, // 需自定义
  },
  {
    name: 'emoji',
    icon: 'expression',
    label: '表情',
    command: (editor) => {}, // 需自定义
  },
  {
    name: 'image',
    icon: 'photoBar',
    label: '图片',
    command: (editor) => {}, // 需自定义
  },
  {
    name: 'video',
    icon: 'videoBar',
    label: '视频',
    command: (editor) => {}, // 需自定义
  },
  {
    name: 'vote',
    icon: 'vote',
    label: '投票',
    command: (editor) => {}, // 需自定义
  },
];
